import React, { useState, useEffect } from "react";
import styled from "styled-components";
import LauncherButtonModule from "./LauncherButtonModule";
import { useEventListener } from "./hooks";

const CoverImg = styled.img`
  /* min-width: ${props => props.minWidth}px; */
  width: auto;
  height: 100%;
`;
const Vignette = styled.div`
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.6) 100%
  );
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 1;
  top: 0;
`;
const Home = props => {
  const [activeDiv, setactiveDiv] = useState(0);
  const [minWidth, setminWidth] = useState(0);
  const [appConfig, setAppConfig] = useState({
    tepcpaper: {},
    tepcpashmina: {}
  });
  // const handleMouseOver = id => {
  //   if (id === "paperLauncher") {
  //     setactiveDiv(1);
  //   } else {
  //     setactiveDiv(2);
  //   }
  // };

  useEffect(() => {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", "explorug-launcher-config.json", true);
    xhr.responseType = "json";
    xhr.onload = function() {
      var status = xhr.status;
      if (status === 200) {
        setAppConfig(xhr.response);
      } else {
        console.log(status);
      }
    };

    xhr.send();
    setminWidth(window.innerWidth * 0.6);
  }, []);

  useEventListener("resize", () => {
    setminWidth(window.innerWidth * 0.6);
  });

  const explorugHome = () => {
    window.open("https://www.explorug.com", "_blank");
  };

  const imageClickFunc = (clickLink) => {
    window.open(clickLink, "_blank");
  };

  return (
    <React.Fragment>
      <div className={"container"} onMouseLeave={() => setactiveDiv(0)}>
        <button className="explorugHomeBtn" onClick={explorugHome}>
          Go to explorug home
        </button>
        <div className="infoDiv">
          <img src="./info-circle.png" alt="circle"></img>
          <span>
            Explorug for Handicrafts features customizable
            <br /> designs visualized on custom Nepali products.
          </span>
        </div>
        <LauncherButtonModule
          className={"paperLauncherModule"}
          label={appConfig.tepcpaper.label}
          clickLink={appConfig.tepcpaper.link}
        />
        <LauncherButtonModule
          className={"pashminaLauncherModule"}
          label={appConfig.tepcpashmina.label}
          clickLink={appConfig.tepcpashmina.link}
        />
        <div className={"paperLauncherContainer"}>
          <div
            className={`${
              activeDiv !== 0 ? (activeDiv === 1 ? "active " : "inactive ") : ""
            } paperLauncher`}
            onMouseOver={() => setactiveDiv(1)}
            onClick={()=>imageClickFunc(appConfig.tepcpaper.link)}
          >
            <CoverImg
              src={appConfig.tepcpaper.imageUrl}
              minWidth={minWidth}
            ></CoverImg>
            <Vignette></Vignette>
            {/* <div className="launcherButtoncontainer">

            </div> */}
            {/* <LauncherButtonModule
              label={appConfig.tepcpaper.label}
              clickLink={appConfig.tepcpaper.link}
            /> */}
          </div>
        </div>
        <div className={"pashminaLauncherContainer"}>
          <div
            className={`${
              activeDiv !== 0 ? (activeDiv === 2 ? "active " : "inactive ") : ""
            } pashminaLauncher`}
            onMouseOver={() => setactiveDiv(2)}
            onClick={()=>imageClickFunc(appConfig.tepcpashmina.link)}
          >
            <CoverImg
              src={appConfig.tepcpashmina.imageUrl}
              minWidth={minWidth}
            ></CoverImg>
            <Vignette></Vignette>
            {/* <div className={activeDiv != 0 ? "active ":""+"launcherButtoncontainer"}>

            </div> */}
            {/* <LauncherButtonModule
              label={appConfig.tepcpashmina.label}
              clickLink={appConfig.tepcpashmina.link}
            /> */}
          </div>
        </div>
        {/* <div class="test1"> </div>
        <div class="test2"> </div>
        <div class="test3"> </div> */}
      </div>
    </React.Fragment>
  );
};

export default Home;
